import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const AppProviders = lazy(() => import('@app/components/AppProviders'))
const ProAiUpsellTag = lazy(() =>
	import('./ProAiUpsellTag').then((m) => ({ default: m.ProAiUpsellTag })),
)

class ProAiUpsellTagWebComponent extends ReactWebComponent {
	static get observedAttributes() {
		return ['team-uuid', 'project-id']
	}

	override render() {
		return (
			<AppProviders>
				<ProAiUpsellTag teamUuid={this.prop('team-uuid')} projectId={this.prop('project-id')} />
			</AppProviders>
		)
	}
}

customElements.define('pro-ai-upsell-tag', ProAiUpsellTagWebComponent)

export { ProAiUpsellTagWebComponent }
